import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
    QuickCriteria,
    QuickCriteriaFilter,
    QuickResultType,
} from '../../../../Search/Quick/Criteria/quickCriteria.model';
import { SearchService } from '../../../../Search/search.service';
import { TimerService } from '../../../../UI-Lib/Utilities';
import { ProcessingService } from '../../../processing.service.upgrade';

@Component({
    selector: 'document-processing-search-result',
    templateUrl: './documentProcessingSearchResult.component.html',
    standalone: false,
})
export class DocumentProcessingSearchResultComponent implements OnInit {
    constructor(
        private readonly _searchService: SearchService,
        private readonly _processingService: ProcessingService,
        private readonly _timer: TimerService,
        private readonly _toastr: ToastrService,
    ) {}

    @Input() criteria: QuickCriteria;
    @Input() resultTypes: QuickResultType[];
    @Input() showCriteria: boolean;

    @Output() resultSelected: EventEmitter<any> = new EventEmitter();

    loading = false;
    allowToShowSpinner = true; // we can hide spinner if it's unlikely that there are more results
    itemsPerPage = 30;
    results: any[] = [];
    resultType: string;
    extraFilters: QuickCriteriaFilter[] = [];

    async ngOnInit(): Promise<void> {
        this.resultType = this.criteria.resultType;
        this.loadExtraFilters();
        await this.getResults();
    }

    async getResults(): Promise<void> {
        this.loading = true;

        try {
            const pageNumber = this.results ? Math.ceil(this.results.length / this.itemsPerPage) + 1 : 1;

            const resultsObj = await this._processingService.search(
                pageNumber,
                this.itemsPerPage,
                this.criteria,
                this.resultTypes,
            );

            if (resultsObj.results && resultsObj.results[0]?.error) {
                if (resultsObj.results[0].error == 'too many rows') {
                    this._toastr.error('Please narrow your search criteria', 'Too many results!');
                } else if (resultsObj.results[0].error == 'Execution Timeout Expired') {
                    this._toastr.error('Please narrow your search criteria', 'Search has taken too long!');
                }
                this.showCriteria = true;
                return;
            }

            this.results = this.results.concat(resultsObj.results);

            if (this.results.length === 1) {
                this._timer.setTimeout(() => {
                    this.resultClicked(this.results[0]);
                }, 1000);
            }
        } finally {
            this.loading = false;
        }
    }

    loadExtraFilters(): void {
        const fieldsToReject = ['parcelPropType', 'parcelAcctNum', 'taxYear'];

        this.extraFilters.filter((x) => !!x.text || !x.default || !fieldsToReject.includes(x.field));
    }

    resultClicked(result): void {
        this.criteria.executeSearch = false;

        const type = this.resultTypes.find((x) => x.type === this.resultType);
        const resultId = result.entityID ? result.entityID : result[`${this.resultType}ID`];

        const entityDetails = {
            entityTypeId: type.id,
            entityId: resultId,
        };

        this.resultSelected.emit(entityDetails);
    }

    pgDn(e: Event, index: number): void {
        let focused = index + 10;
        const lastIndex = this.results.length - 1;

        focused = focused > lastIndex ? lastIndex : focused;

        this._searchService.focusOnResult(focused);
        e.preventDefault();
    }

    pgUp(e: Event, index: number): void {
        let focused = index - 10;
        focused = focused < 0 ? 0 : focused;

        this._searchService.focusOnResult(focused);
        e.preventDefault();
    }

    keyup($event: KeyboardEvent, index: number): void {
        if ($event.code === '34') {
            this.pgDn($event, index);
        } else if ($event.code === '33') {
            this.pgUp($event, index);
        }
    }

    hoverIn(index: number): void {
        this._searchService.focusOnResult(index);
    }
}
